import { render, staticRenderFns } from "./Processing.vue?vue&type=template&id=faa53004"
import script from "./Processing.vue?vue&type=script&lang=js"
export * from "./Processing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faa53004')) {
      api.createRecord('faa53004', component.options)
    } else {
      api.reload('faa53004', component.options)
    }
    module.hot.accept("./Processing.vue?vue&type=template&id=faa53004", function () {
      api.rerender('faa53004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/Processing.vue"
export default component.exports